import {
    UserEmailSettingsResource,
    UserIdentityResource,
} from 'dy-frontend-http-repository/lib/modules/User/resources';
import domain from './domain';
import { resetUserEmailSettings, resetUserIdentity } from './events';

// User identity
export const $userIdentity = domain.createStore<UserIdentityResource | null>(null).reset(resetUserIdentity);

// User email settings
export const $userEmailSettings = domain
    .createStore<UserEmailSettingsResource | null>(null)
    .reset(resetUserEmailSettings);
